import {connect} from 'react-redux';
import {MoreContext as Component} from './MoreContext';
import {
  showModal
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    }
  };
}

export const MoreContext = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
